/**
 * @author: subhasish.ghosh@zoom.us
 */

import Landing from "../components/Landing";
import useAuthentication from "../hooks/useAuthentication";
import React from "react";

const AuthenticationWrapper = ({ userInfoLoading, children }) => {
  const isAuthenticated = useAuthentication();

  if (userInfoLoading) {
    return <Landing />;
  }

  if (!isAuthenticated) {
    // store search params before login routing
    localStorage.setItem("pre-login-url", window.location);

    // redirect to login
    const redirectUrl = process.env.REACT_APP_LOGIN_REDIRECT_URL;
    if (redirectUrl) {
      window.location = redirectUrl;
      return <Landing />;
    } else {
      console.error(
        "REACT_APP_LOGIN_REDIRECT_URL is not defined for the environment."
      );
      return <Landing />;
    }
  } else {
    // post login, okta routes to domain without search params
    if (window.location.search === "") {
      const preLoginUrl = localStorage.getItem("pre-login-url");
      // if pre-login url is availbale in localstorage, then route the url
      if (preLoginUrl && preLoginUrl !== null) {
        window.location = preLoginUrl;
        // remove pre-login uri
        localStorage.removeItem("pre-login-url");
        return <Landing />;
      }
    }
  }

  return <>{children}</>;
};

export default AuthenticationWrapper;
